import { useMemo } from 'react'
import cn from 'clsx'

import './DocumentPagesViewer.css'

const DocumentPagesViewer = ({
    pageUrls,
    pageIndex,
    setPageIndex,
}) => {
    
    const activeImageUrl = useMemo(() => pageUrls?.[pageIndex] ?? null, [pageUrls, pageIndex])
    
    if (!pageUrls?.length) return null
    
    return (
        
        <div className="DocumentPagesViewer">
            
            <aside className="page-previews">
                {pageUrls.map((it, i) => (
                    <div
                        key={it}
                        className={cn('page-preview', {
                            active: pageIndex === i,
                        })}
                        onClick={() => setPageIndex(i)}>
                        <img src={it} />
                    </div>
                ))}
            </aside>
            
            <section className="viewer">
                
                <img src={activeImageUrl} />
            
            </section>
        
        </div>
        
    )
    
}

export default DocumentPagesViewer
